module.exports = __webpack_public_path__ + "static/img/jd-img1.94475fe.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/jd-img1.png
// module id = 828
// module chunks = 0